import React from 'react';
import './radio-button-group.scss';

export function RadioButtonGroup({ automationId, children, className = '' }) {
  return (
    <div
      role="group"
      className={`RadioButtonGroup columns is-mobile is-centered is-gapless ${className ? className : ''}`}
      automationid={automationId}
    >
      {children.map((child, index) => (
        <div className="column centered" key={index}>{child}</div>
      ))}
    </div>
  );
}
